import styled, { css } from "styled-components";

export const ActionsColumnSC = styled.div`
    position: absolute;
    right: -0.1em;
    top: 50%;
    z-index: 2;
    transform: translateY(-50%);
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 5px;
    opacity: 0;
    transition: opacity 0.2s;
`;

export const ActionButtonSC = styled.div<{ disabled?: boolean; color?: string }>`
    color: ${({ disabled, color }) => (disabled ? "#EBEBE4" : color || "var(--accent)")};
    cursor: ${({ disabled }) => (disabled ? "no-drop" : "pointer")};
    display: flex;
    align-items: center;
    justify-content: center;
`;

// Keep compatibility if needed, but better to replace usage
export const ForwardIconWrapperSC = ActionButtonSC;

export const SubtitleContainerSC = styled.div<{
    right?: string;
    full?: string;
    isactive: string;
    red?: string;
    searchhighlight?: string;
}>`
    text-align: left;
    font-family:
        Ubuntu Mono,
        sans-serif;
    line-height: 1em;
    position: absolute;
    left: var(--audio-track-width);
    right: auto;
    color: #000;
    min-width: ${({ full }) =>
        full === "true"
            ? "calc(95vw - 0.5em - (var(--audio-track-width) + var(--audio-time-width) + (var(--audio-player-width) / 2)))"
            : "calc(50vw - 0.5em - (var(--audio-track-width) + var(--audio-time-width) + (var(--audio-player-width) / 2)))"};
    border-radius: var(--radius);
    background-color: ${({ red, searchhighlight }) => {
        if (searchhighlight === "true") return "#fffbe6";
        if (red === "red") return "red";
        return "#00000008";
    }};
    ${({ searchhighlight }) => searchhighlight === "true" && css`
        outline: 2px solid #faad14;
        outline-offset: -1px;
    `}
    transition: opacity 0.2s;
    z-index: 1;
    cursor: pointer;
    flex-flow: column;
    flex: 1 1;
    display: flex;
    ${({ right }) => {
        if (right === "true") {
            return css`
                left: calc(
                    50vw -
                        (
                            var(--audio-track-width) + var(--audio-time-width) +
                                (var(--audio-player-width) / 2)
                        ) +
                        var(--audio-track-width)
                );
            `;
        }
    }}

    & .xt_textarea_actions {
        opacity: 0;
    }

    &:hover .xt_textarea_actions {
        opacity: ${({ isactive }) => {
        if (isactive === "none" || isactive === "true") {
            return 1;
        } else {
            return 0;
        }
    }};
    }
    &:hover ${ActionsColumnSC} {
        opacity: ${({ isactive }) => {
        if (isactive === "none" || isactive === "true") {
            return 1;
        } else {
            return 0;
        }
    }};
    }
`;

/**
 * Красная метка «время реплики испорчено» с починкой одним нажатием. Левее колонки действий
 * (ActionsColumnSC — «Skip» и «→» у правого края): иначе метка закрыла бы «→».
 */
export const BrokenTimeSC = styled.div`
    position: absolute;
    top: 2px;
    right: 5.5em;
    z-index: 3;
    display: flex;
    align-items: center;
    gap: 4px;
    padding: 0 6px;
    border: 1px solid #ffccc7;
    border-radius: 4px;
    background-color: #fff2f0;
    color: #cf1322;
    font-size: 11px;
    line-height: 16px;
    white-space: nowrap;

    & [data-restore-window] {
        cursor: pointer;
        text-decoration: underline;
    }
`;

/**
 * Метка «⊘ снята с озвучки» на переводе с «вернуть». Там же, где «⚠ время» у оригинала: левее
 * колонки ♪ и 🔊.
 */
export const SkippedSC = styled.div`
    position: absolute;
    top: 2px;
    right: 5.5em;
    z-index: 3;
    display: flex;
    align-items: center;
    gap: 4px;
    padding: 0 6px;
    border: 1px solid #ffd591;
    border-radius: 4px;
    background-color: #fff7e6;
    color: #d46b08;
    font-size: 11px;
    line-height: 16px;
    white-space: nowrap;

    & [data-unskip] {
        cursor: pointer;
        text-decoration: underline;
    }
`;

/**
 * Кусок фразы, чей русский текст тот же, что у куска 1: вместо второй (третьей…) копии фразы —
 * одна строка «↳ продолжение фразы i/n», сама фраза в подсказке. Не редактируется.
 */
export const PhraseContinuesSC = styled.div<{ $repeat?: boolean }>`
    padding: 5px 10px;
    /* Кусок-повтор (перевод как у соседнего куска) — настоящий повтор в дубляже: красным. */
    color: ${({ $repeat }) => ($repeat ? "#cf1322" : "#8c8c8c")};
    font-style: italic;
    line-height: normal;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
`;

/**
 * Небольшая метка «фраза i/n» у куска, который показывает русский текст фразы. Внизу, левее
 * колонки действий: вверху место метки «⚠ время».
 */
export const PhrasePieceBadgeSC = styled.div<{ $repeat?: boolean }>`
    position: absolute;
    bottom: 2px;
    right: 5.5em;
    z-index: 3;
    padding: 0 6px;
    border: 1px solid ${({ $repeat }) => ($repeat ? "#ffa39e" : "#d6e4ff")};
    border-radius: 4px;
    background-color: ${({ $repeat }) => ($repeat ? "#fff1f0" : "#f0f5ff")};
    color: ${({ $repeat }) => ($repeat ? "#cf1322" : "#1d39c4")};
    font-size: 11px;
    line-height: 16px;
    white-space: nowrap;
    pointer-events: auto;
`;

/**
 * Кто говорит перевод — «лектор» или «зал · Michael» (проба P50m10d, E6: ♪ попал в реплику зала вместо лектора,
 * строки выглядели одинаково). Метка поверх строки, как «⚠ время» и «⊘ снята»: высоту строки и ленты не меняет.
 * Вверху левее колонки ♪ и 🔊 — там, где у снятой реплики «⊘ снята» (у неё подписи нет: её не озвучивают). Метки
 * «⚠ время» и «фраза i/n» — только в колонке оригинала. Зал — фиолетовым, лектор — серым.
 */
export const SpeakerBadgeSC = styled.div<{ $hall?: boolean }>`
    position: absolute;
    top: 2px;
    right: 5.5em;
    z-index: 3;
    padding: 0 6px;
    border: 1px solid ${({ $hall }) => ($hall ? "#d3adf7" : "#d9d9d9")};
    border-radius: 4px;
    background-color: ${({ $hall }) => ($hall ? "#f9f0ff" : "#fafafa")};
    color: ${({ $hall }) => ($hall ? "#531dab" : "#595959")};
    font-size: 11px;
    line-height: 16px;
    white-space: nowrap;
    pointer-events: auto;
`;

export const IconWrapperSC = styled.div<{ color?: string }>`
    display: flex;
    border-radius: var(--radius);
    background-color: ${({ color }) => (color ? color : "var(--accent)")};
    color: #fff;
    text-align: center;
    cursor: pointer;
    justify-content: center;
    align-items: center;
    height: 2em;
    font-weight: 500;
    line-height: 1em;
    transition: opacity 0.2s;
    width: 3em;
    padding: 0.5em;
`;
